// extracted by mini-css-extract-plugin
export default {"movie_page_poster":"MoviePagePoster_movie_page_poster__cqlz-","border_radius":"MoviePagePoster_border_radius__C4a3i","wishlist":"MoviePagePoster_wishlist__2T47T"};